import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {openChat} from "../utilities";
import {connect} from 'react-redux';
import {addChatOpenedCount} from "../redux/actions";


class ChatScrollTrigger extends Component {
  constructor(props) {
    super(props);
    this.timer = null;
  }

  componentDidMount() {
    if (this.props.percentage !== null) {
      window.addEventListener('scroll', this.handleScroll);
      this.handleScroll();
    }
    if (this.props.time !== null) {
      this.timer = setTimeout(() => {
        this.openChatPolite();
      }, this.props.time * 1000);
    }
  }

  componentWillUnmount() {
    if (this.props.percentage) {
      window.removeEventListener('scroll', this.handleScroll);
    }
    if (this.props.time !== null) {
      clearTimeout(this.timer);
    }
  }

  openChatPolite = () => {
    if (this.props.chatOpenedCount < 1) {
      openChat();
      this.props.incrementChatOpenedCount();
    }
  };

  handleScroll = () => {
    const screenBottom = window.innerHeight + (document.scrollingElement || document.documentElement).scrollTop;
    const triggerPoint = document.body.clientHeight * this.props.percentage;

    if (screenBottom > triggerPoint) {
      this.openChatPolite();
    }
  };

  render() {
    return null;
  }
}

ChatScrollTrigger.propTypes = {
  percentage: PropTypes.number,
  time: PropTypes.number,
  force: PropTypes.bool,
};

export default connect((state) => ({
  chatOpenedCount: state.chatOpenedCount
}), (dispatch) => ({
  incrementChatOpenedCount: () => dispatch(addChatOpenedCount())
}))(ChatScrollTrigger);


// WEBPACK FOOTER //
// ./src/parts/ChatScrollTrigger.js